import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-phone",
  "use": "icon-phone-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-phone\"><path d=\"M544 910.336h-64a32 32 0 0 1 0-64h64a32 32 0 0 1 0 64zM560 192h-96a32 32 0 0 1 0-64h96a32 32 0 0 1 0 64zM816 800h-608a32 32 0 0 1 0-64h608a32 32 0 0 1 0 64z\" p-id=\"32670\" fill=\"#ffffff\" /><path d=\"M784 1024h-544c-35.264 0-64-28.672-64-64V64c0-35.264 28.736-64 64-64h544c35.328 0 64 28.736 64 64v896a64 64 0 0 1-64 64z m0-64v32-32zM240 64v896h544V64h-544z\" p-id=\"32671\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol